import { createContext } from 'react';

// Session + the latest sidebar overview poll. Layout owns the polling and
// publishes results here so the Overview page can read counts directly
// rather than re-fetching the same endpoint on mount.
export const SessionContext = createContext(null);
